import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ActivityBarIcon = ({ icon: Icon, label, path }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const active = pathname === path;

  return (
    <div className="group relative flex w-full justify-center">
      <button
        onClick={() => navigate(path)}
        title={label}
        className={`flex h-12 w-12 items-center justify-center border-l-2 ${
          active
            ? "border-vscode-accent text-vscode-textBright"
            : "border-transparent text-vscode-textMuted hover:text-vscode-text"
        }`}
      >
        <Icon size={24} strokeWidth={1.5} />
      </button>
      <span
        className="pointer-events-none absolute left-full top-1/2 z-30 ml-2 -translate-y-1/2 whitespace-nowrap rounded-sm bg-vscode-titlebar px-2 py-1 text-xs text-vscode-textBright opacity-0 shadow-md transition-opacity group-hover:opacity-100"
      >
        {label}
      </span>
    </div>
  );
};

const ActivityBar = ({ tools }) => {
  return (
    <aside className="flex w-12 shrink-0 flex-col justify-between bg-vscode-activitybar">
      <nav className="flex flex-col items-center pt-1">
        {tools.map((tool) => (
          <ActivityBarIcon key={tool.path} {...tool} />
        ))}
      </nav>
      <div className="flex flex-col items-center pb-2">
        <a
          href="https://github.com/Arinaymaybhaskar"
          target="_blank"
          rel="noreferrer"
          title="GitHub"
          className="flex h-12 w-12 items-center justify-center text-vscode-textMuted hover:text-vscode-text"
        >
          <img src="/github.svg" alt="GitHub" className="h-5 w-5 invert opacity-70" />
        </a>
        <a
          href="https://www.linkedin.com/in/arinaymay/"
          target="_blank"
          rel="noreferrer"
          title="LinkedIn"
          className="flex h-12 w-12 items-center justify-center text-vscode-textMuted hover:text-vscode-text"
        >
          <img src="/linkedin.svg" alt="LinkedIn" className="h-5 w-5 invert opacity-70" />
        </a>
      </div>
    </aside>
  );
};

export default ActivityBar;
